import { ReactNode } from "react"
import { useSignal } from "~/sdk/signal"

export interface Props {
    id: string
    children: ReactNode
}

export default function FilterItemCollapse({ id, children }: Props) {
    const opened = useSignal(false)

    return (
        <li className='collapse relative rounded-none min-h-[20px] p-0 pb-6'>
            <input
                type='checkbox'
                id={id}
                className='hidden peer'
                onChange={() => {
                    opened.value = true
                }}
            />

            <label
                htmlFor={id}
                className='collapse-title font-bold text-base text-salmon p-0 pb-1 min-h-0 h-5 w-full flex items-center justify-start absolute bottom-0 group/check gap-x-1'
            >
                <span className='underline underline-offset-4'>
                    {opened.value ? 'Ver menos' : 'Ver mais'}
                </span>

                <span>
                    [{opened.value ? '-' : '+'}]
                </span>
            </label>

            <ul className='collapse-content flex gap-3 flex-col p-0 pt-[2px]'>
                {opened.value && children}
            </ul>
        </li>
    )
}
